
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Signature extends Vue {  
  @Prop() content!: string;  
}
